import { routeConstants } from "../constants";
import { checkSegments } from "./util";

export const isInApp = checkSegments({
  oneOf: [
    routeConstants.app14DayWebReturning,
    routeConstants.app14DayReturning,
    routeConstants.app14DayWeb,
    routeConstants.app14DayFtWeb,
    routeConstants.app14Day,
    routeConstants.appNoTrial,
    routeConstants.appNoTrialReturning,
  ],
});
export const isInAppWinback = checkSegments({
  oneOf: [
    routeConstants.app14DayFtWeb,
    routeConstants.app14DayReturning,
    routeConstants.app14DayWebReturning,
    routeConstants.appNoTrialReturning,
  ],
});
export const isInApp14DayiOS = checkSegments({
  oneOf: [routeConstants.app14Day, routeConstants.app14DayReturning],
});
export const isApp14DayBaseRoute = checkSegments({
  required: isInApp,
  oneOf: [routeConstants.app14DayWeb, routeConstants.app14Day],
});
